var EPK = EPK || {};
EPK.Brand = EPK.Brand || {};
EPK.Brand = function(){};

EPK.Brand.prototype.initialize = function(){

	var _this = this;
	var $searchBox = $("#searchBox");

	var $tabarea = $("#tab-area");
	var $tabStations = $("#tab-station");
	var $tabPrescription = $("#tab-prescription");
	var $tabRecruits = $("#tab-recruit");
	var $tabCreditcard = $("#tab-creditcard");
	var $tabParking = $("#tab-parking");
	var $tabBarrierFree = $("#tab-barrierfree");
	var $tabSaturday = $("#tab-saturday");
	var $tabSunday = $("#tab-sunday");
	var $tabHoliday = $("#tab-holiday");
	var $tabConsulting = $("#tab-consulting");

	var $buttonTabArea = $(".brand_tab .area");
	var $btnCurrentPlace = $("#search-by-current-space");

	// $btnCurrentPlace.on("click",function(event){
	// 	_this.currentPlace(event);
	// 	return false;
	// });

	$buttonTabArea.on("click",function(event){
		$searchBox.children().first().appendTo("#hiddenArea");
		$tabarea.clone().appendTo("#searchBox");
		_this.toggleActive($(event.target));
	});
	$(".brand_tab .station").on("click",function(event){
		$searchBox.children().first().appendTo("#hiddenArea");
		$tabStations.clone().appendTo("#searchBox");
		_this.toggleActive($(event.target));
	});
	$(".brand_tab .recruit").on("click",function(event){
		$searchBox.children().first().appendTo("#hiddenArea");
		$tabRecruits.clone().appendTo("#searchBox");
		_this.toggleActive($(event.target));
	});
	$(".brand_tab .net").on("click",function(event){
		$searchBox.children().first().appendTo("#hiddenArea");
		$tabPrescription.clone().appendTo("#searchBox");
		_this.toggleActive($(event.target));
	});
	$(".brand_tab .credit").on("click",function(event){
		$searchBox.children().first().appendTo("#hiddenArea");
		$tabCreditcard.clone().appendTo("#searchBox");
		_this.toggleActive($(event.target));
	});
	$(".brand_tab .parking").on("click",function(event){
		$searchBox.children().first().appendTo("#hiddenArea");
		$tabParking.clone().appendTo("#searchBox");
		_this.toggleActive($(event.target));
	});
	$(".brand_tab .barrier").on("click",function(event){
		$searchBox.children().first().appendTo("#hiddenArea");
		$tabBarrierFree.clone().appendTo("#searchBox");
		_this.toggleActive($(event.target));
	});
	$(".brand_tab .sut").on("click",function(event){
		$searchBox.children().first().appendTo("#hiddenArea");
		$tabSaturday.clone().appendTo("#searchBox");
		_this.toggleActive($(event.target));
	});
	$(".brand_tab .sun").on("click",function(event){
		$searchBox.children().first().appendTo("#hiddenArea");
		$tabSunday.clone().appendTo("#searchBox");
		_this.toggleActive($(event.target));
	});
	$(".brand_tab .holiday").on("click",function(event){
		$searchBox.children().first().appendTo("#hiddenArea");
		$tabHoliday.clone().appendTo("#searchBox");
		_this.toggleActive($(event.target));
	});
	$(".brand_tab .talk").on("click",function(event){
		$searchBox.children().first().appendTo("#hiddenArea");
		$tabConsulting.clone().appendTo("#searchBox");
		_this.toggleActive($(event.target));
	});

	$searchBox.children().first().appendTo("#hiddenArea");
	$tabarea.clone().appendTo("#searchBox");
	// グループブランドのスライダー設定
	this.createGroupBrandSwiper();
};

EPK.Brand.prototype.toggleActive = function(activeElement){
	$(".brand_tab").find("li").each(function(){
		$(this).removeClass("active");
	});
	$(activeElement).addClass("active");
};

EPK.Brand.prototype.currentPlace = function(event) {

	if (navigator.geolocation) {
		// 現在地を取得
		navigator.geolocation.getCurrentPosition(
			_moveTo,
			_errorHandler,
			{
				"enableHighAccuracy": false,
				"timeout": 8000,
				"maximumAge": 2000,
			}
		);
	}else {
		// エラーメッセージ
		var errorMessage = "現在地情報を取得できませんでした。<br>端末の設定より現在地情報サービスをオンにして下さい。";
		// アラート表示
		alert(errorMessage);
	}

	function _moveTo(position) {
		var data = position.coords ;

		var lat = data.latitude;
		var lng = data.longitude;
		var full = location.protocol+'//'+location.hostname+(location.port ? ':'+location.port: '');
		var locationString = full + EPK.BrandArgs.baseURL +'&lat=' + lat + '&lng=' + lng;

		console.log(locationString);
		window.location.href = locationString;
	}

	function _errorHandler(error) {
		// エラーコード(error.code)の番号
		// 0:UNKNOWN_ERROR				原因不明のエラー
		// 1:PERMISSION_DENIED			利用者が位置情報の取得を許可しなかった
		// 2:POSITION_UNAVAILABLE		電波状況などで位置情報が取得できなかった
		// 3:TIMEOUT					位置情報の取得に時間がかかり過ぎた…

		// エラー番号に対応したメッセージ
		var errorInfo = [
			"原因不明のエラーが発生しました…。",
			"位置情報の取得が許可されませんでした…。",
			"電波状況などで位置情報が取得できませんでした…。",
			"位置情報の取得に時間がかかり過ぎてタイムアウトしました…。"
		];

		console.error(error);

		// エラー番号
		var errorNo = error.code;

		// エラーメッセージ
		var errorMessage = "[エラー番号: " + errorNo + "]\n" + errorInfo[errorNo];

		// アラート表示
		alert(errorMessage);
	}

};
/**
 * チラシを表示するエレメントの高さを設定
 * @method setTirashiElementHeight
 */
EPK.Brand.prototype.setTirashiElementHeight = function () {
  // チラシ用
  var $flyerListBox = $('.flyer-list-box');
  $flyerListBox.each(function (i, box) {
    var $box = $(box);
    var maxHeight = 0;
    var $flyerShopname = $box.find('.flyer-shopname');
    var $flyerRouteAddress = $box.find('.flyer-route-address');
    var $flyerName = $box.find('.flyer-name');
    var $useItemBox = $box.find('.use-item-box');

    // flyer-shopnameクラスの高さを変更
    $flyerShopname.each(function () {
      var height = $(this).height();
      if (height > maxHeight) maxHeight = height;
    });
    $flyerShopname.height(maxHeight);
    // flyer-route-addressクラスの高さを変更
    maxHeight = 0;
    $flyerRouteAddress.each(function () {
      var height = $(this).height();
      if (height > maxHeight) maxHeight = height;
    });
    $flyerRouteAddress.height(maxHeight);
    // flyer-nameクラスの高さを変更
    maxHeight = 0;
    $flyerName.each(function () {
      var height = $(this).height();
      if (height > maxHeight) maxHeight = height;
    });
    $flyerName.height(maxHeight);
    // use-item-boxクラスの高さを変更
    maxHeight = 0;
    $useItemBox.each(function () {
      var height = $(this).height();
      if (height > maxHeight) maxHeight = height;
    });
    $useItemBox.height(maxHeight);
  });
};
/**
 * グループブランドのスライダー作成
 * @method createGroupBrandSwiper
 */
EPK.Brand.prototype.createGroupBrandSwiper = function() {
	var optionParam = {
		initialSlide: 0,
		loop: false,
		slidesPerView: 'auto',
		scrollbarHide: true,
		centeredSlides: false,
		grabCursor: true,
		slidesOffsetAfter: 20,
		spaceBetween: 9,
	};
	if(!EPK.common.isMobile) { // PCの場合
		optionParam.pagination =  document.querySelector('#group-brand-swiper .swiper-pagination');
		optionParam.nextButton =  '.swiper-button-next';
		optionParam.prevButton =  '.swiper-button-prev';
		optionParam.autoplay =  '5000';
		optionParam.loop =  'true';
		optionParam.slidesPerView = '9';
		optionParam.spaceBetween = 7;
		optionParam.disableOnInteraction = 'false';
	}
	// スライダー作成
	$('#group-brand-swiper').swiper(optionParam);

};

$(function(){
	var brand = new EPK.Brand();
	brand.initialize();

	$('#new_shops_slider').swiper({
		initialSlide: 0,
		loop: true,
		width: 410,
		slidesPerView: 1,
		spaceBetween: 10,
		pagination:document.querySelector('.brand-info-pagebtn .swiper-pagination'),
		nextButton: '.swiper-button-next',
		prevButton: '.swiper-button-prev',
		autoplay: '5000',
		autoplayDisableOnInteraction: 'false'
	});
  // チラシの高さを設定(速度改修のためにタイミングを変更)
  var timeoutHandle = setTimeout(function () {
    clearTimeout(timeoutHandle);
    brand.setTirashiElementHeight();
  }, 0);
});





// 以下ブランドTOP新規ページ用



/**
 * SP版セレクトボックス処理
 * セレクトボックスを変更したときに対象以外をdisplay　noneに設定
 * @method BrandShopSelect
 */
EPK.Brand.prototype.BrandShopSelect = function (elem,event) {
	var selectValue,
		target = document.getElementsByClassName("brand-shoplist"),
		targetlength = target.length;

	//セレクトボックス取得
	select = document.getElementById("pref-select");
	elem.addEventListener(event,function () {
		selectValue = select.value;

		//対象以外非表示処理
		for (var i = 0; i < targetlength; i++) {
			//全国の場合は全て表示する
			if (selectValue === "all") {
				target[i].style.display = "block";
			}else if (!target[i].classList.contains(selectValue)) {
				target[i].style.display = "none";
			}else{
				target[i].style.display = "block";
			}
		}
	})
}

/**
 * SP版 新着の口コミ情報を取得
 * @method clickReviewListMore
 */
 EPK.Brand.prototype.reviewListLoadMore = function () {
	$('.review-list-more a').addClass('unclickable');
	$('.review-list-more .loading img').fadeIn();

	var reviewListLoadMore = $(event.target).closest('.review-list-more-btn');

	var kmBrandPageId = reviewListLoadMore.data('km_brand_page_id');
	var page = reviewListLoadMore.data('page');

	if(!kmBrandPageId) {
		return false;
	}

	if(!$.isNumeric(page)){
		return false;
	}

	$.ajax({
		type: 'POST',
		url: '/api/brand/review_list_load_more/' + kmBrandPageId,
		data: {
				'km_brand_page_id': kmBrandPageId,
				'page': page,
			},
		cache: false,
		dataType : 'html',
		timeout: 50000
	}).done(function(data){
		if(data.length > 0){
			$('.brand-new-review-list').append(data);
			$('.review-list-more .loading img').fadeOut();
			$('#review-list-pager_' + page).remove();
		}else{
			console.log('/api/brand/review_list_load_more/ data is empty');
		}

	}).fail(function(data){
		$('.review-list-more .loading img').fadeOut();
		console.log('/api/brand/review_list_load_more/ failed');
		console.log(data);
		return false;
	});
};

/**
 * SP版 動画の描画
 * @method videoRender
 */
 EPK.Brand.prototype.videoRender = function () {
	var src = {
		mp4:"/img/campaigns/epk-enq-movie-brand01/movie.mp4",
		webm:"/img/campaigns/epk-enq-movie-brand01/movie.webm",
		ogv:"/img/campaigns/epk-enq-movie-brand01/movie.ogv",
	}
	if(Object.keys(src).length){
		Object.keys(src).forEach(function (key,i) {
			var source = document.createElement("source");
			source.setAttribute("type","video/"+key+"");
			source.src = src[key];
			document.getElementById("video").insertAdjacentElement("beforeend",source);
		})
	}
 };

/** 
 * SP版 こだわり条件を取得
 * @method getCommitmentCond
 */
EPK.Brand.prototype.getCommitmentCond = function () {
	var objSection = $('#commitment-cond-async');
	var kmBrandPageId = EPK.common.params['km_brand_page_id'];

	if (!kmBrandPageId) {
		return false;
	}

	$.ajax({
		type: 'POST',
		url: '/api/brand/commitment_cond/' + kmBrandPageId,
		data: {},
		cache: false,
		dataType : 'html',
		timeout: 50000
	}).done(function(data, textStatus, jqXHR) {
		if (data) {
			objSection.empty();
			objSection.append(data);
			objSection.css('display','');

		} else {
			console.log('/api/brand/commitment_cond/ data is empty');
		}

	}).fail( function(data, textStatus, jqXHR) {
		console.log('/api/brand/commitment_cond/ failed');
		console.log(data);
		return false;
	});
};

/**
 * SP版 新着・更新のあった店舗を取得
 * @method getUpdatedShopList
 */
EPK.Brand.prototype.getUpdatedShopList = function () {
	var objSection = $('#updated-shop-list-itemslide-async');
	var kmBrandPageId = EPK.common.params['km_brand_page_id'];

	if (!kmBrandPageId) {
		return false;
	}

	$.ajax({
		type: 'POST',
		url: '/api/brand/updated_shop_list/' + kmBrandPageId,
		data: {},
		cache: false,
		dataType : 'html',
		timeout: 50000
	}).done(function(data, textStatus, jqXHR) {
		if (data) {
			objSection.empty();
			objSection.append(data);
			objSection.css('display','');

			//更新のあった店舗スライダー
			var shopSwiper = $('#new-update-shop-swiper').swiper({
				slidesPerView: "auto",
				centeredSlides: true,
				spaceBetween: 12,
				loop: true,
			});

		} else {
			console.log('/api/brand/updated_shop_list/ data is empty');
		}

	}).fail( function(data, textStatus, jqXHR) {
		console.log('/api/brand/updated_shop_list/ failed');
		console.log(data);
		return false;
	});
};

/** 
 * SP版 新着の口コミを取得
 * @method getReviewList
 */
EPK.Brand.prototype.getReviewList = function () {
	var objSection = $('#review-list-async');
	var kmBrandPageId = EPK.common.params['km_brand_page_id'];

	if (!kmBrandPageId) {
		return false;
	}

	$.ajax({
		type: 'POST',
		url: '/api/brand/review_list/' + kmBrandPageId,
		data: {},
		cache: false,
		dataType : 'html',
		timeout: 50000
	}).done(function(data, textStatus, jqXHR) {
		if (data) {
			objSection.empty();
			objSection.append(data);
			objSection.css('display','');

			// SP版 口コミをもっと見る（〇件）クリック
			if($(".review-list-more-btn").length){
				$(".review-list-more-btn").on('click',function() {
					EPK.Brand.prototype.reviewListLoadMore();
				});
			}

		} else {
			console.log('/api/brand/review_list/ data is empty');
		}

	}).fail( function(data, textStatus, jqXHR) {
		console.log('/api/brand/review_list/ failed');
		console.log(data);
		return false;
	});
};

/** 
 * SP版 新着チラシを取得
 * @method getFlyerList
 */
EPK.Brand.prototype.getFlyerList = function () {
	var objSection = $('#flyer-list-itemslide-async');
	var kmBrandPageId = EPK.common.params['km_brand_page_id'];

	if (!kmBrandPageId) {
		return false;
	}

	$.ajax({
		type: 'POST',
		url: '/api/brand/flyer_list/' + kmBrandPageId,
		data: {},
		cache: false,
		dataType : 'html',
		timeout: 50000
	}).done(function(data, textStatus, jqXHR) {
		if (data) {
			objSection.empty();
			objSection.append(data);
			objSection.css('display','');

			// チラシスライダー
			if ($('#new-flyer-brand-slider ul li').length > 2) {
				var flyerswiper = $('#new-flyer-brand-slider').swiper({
					slidesPerView: "auto",
					spaceBetween: 5,
				});
			}

		} else {
			console.log('/api/brand/flyer_list/ data is empty');
		}

	}).fail( function(data, textStatus, jqXHR) {
		console.log('/api/brand/flyer_list/ failed');
		console.log(data);
		return false;
	});
};

/** 
 * SP版 ポイント・クーポンに関するまとめ記事を取得
 * @method getArticlePageAnchor
 */
EPK.Brand.prototype.getArticlePageAnchor = function () {
	var objSection = $('#article-page-anchor-async');
	var kmBrandPageId = EPK.common.params['km_brand_page_id'];

	if (!kmBrandPageId) {
		return false;
	}

	$.ajax({
		type: 'POST',
		url: '/api/brand/article_page_anchor/' + kmBrandPageId,
		data: {},
		cache: false,
		dataType : 'html',
		timeout: 50000
	}).done(function(data, textStatus, jqXHR) {
		if (data) {
			objSection.empty();
			objSection.append(data);
			objSection.css('display','');

		} else {
			console.log('/api/brand/article_page_anchor/ data is empty');
		}

	}).fail( function(data, textStatus, jqXHR) {
		console.log('/api/brand/article_page_anchor/ failed');
		console.log(data);
		return false;
	});
};

/** 
 * SP版 同グループのブランドを取得
 * @method getGroupBrandList
 */
EPK.Brand.prototype.getGroupBrandList = function () {
	var objSection = $('#group-brand-list-itemslide-async');
	var kmBrandPageId = EPK.common.params['km_brand_page_id'];

	if (!kmBrandPageId) {
		return false;
	}

	$.ajax({
		type: 'POST',
		url: '/api/brand/group_brand_list/' + kmBrandPageId,
		data: {},
		cache: false,
		dataType : 'html',
		timeout: 50000
	}).done(function(data, textStatus, jqXHR) {
		if (data) {
			objSection.empty();
			objSection.append(data);
			objSection.css('display','');

			//同グループのスライダー
			var brandSwiper = $('#group-brand-swiper').swiper({
				slidesPerView: "auto",
				spaceBetween: 10,
			});

		} else {
			console.log('/api/brand/group_brand_list/ data is empty');
		}

	}).fail( function(data, textStatus, jqXHR) {
		console.log('/api/brand/group_brand_list/ failed');
		console.log(data);
		return false;
	});
};


/** 
 * SP版 非同期取得の呼び出し
 * @method spAsyncInfo
 */
EPK.Brand.prototype.spAsyncInfo = function () {

	// SP版：#15835 お知らせ枠　非同期実装(お知らせ枠の描画)
	EPK.common.renderTopNotice();

	// SP版：#15834 同グループのブランド　非同期実装
	if($('#group-brand-list-itemslide-async').length) {
		// 同グループのブランドを取得
		this.getGroupBrandList();
	}

	// SP版：#15442 ブランドTOP　こだわり条件を非同期化
	if($('#commitment-cond-async').length) {
		// こだわり条件を取得
		this.getCommitmentCond();
	}

	// SP版：#15444 新着・更新のあった店舗　非同期実装
	if($('#updated-shop-list-itemslide-async').length) {
		// 新着・更新のあった店舗を取得
		this.getUpdatedShopList();
	}

	// SP版：#15445 新着の口コミ　非同期実装
	if($('#review-list-async').length) {
		// 新着の口コミを取得
		this.getReviewList();
	}

	// SP版：#15446 新着チラシ　非同期実装
	if($('#flyer-list-itemslide-async').length) {
		// 新着チラシを取得
		this.getFlyerList();
	}

	// SP版：#15883 ポイント・クーポンに関するまとめ記事　非同期実装
	if($('#article-page-anchor-async').length) {
		// ポイント・クーポンに関するまとめ記事を取得
		this.getArticlePageAnchor();
	}

	// SP版：#15443 xrost/動画　非同期実装(video非同期描画)
	if ($('#video').length) {
		// 動画の描画
		this.videoRender();
	}
};

$(function(){

	var brand = new EPK.Brand();

	//SPセレクトボックス
	if (EPK.common.isSP) {
		var select = document.getElementById("pref-select");
		if (select) {
			//ブラウザバックの際
			brand.BrandShopSelect(window,"load");
			//セレクトを変更した際
			brand.BrandShopSelect(select,"change");
		}

		// SP版：#15838 ブランドTOP　CSSの遅延読み込み
		// 通常パターンのみサーバー側からcssを連携してもらう（キャッシュ、複数パターン、listingは除外）
		var $asyncAddCss = $('input[type="hidden"][class="async-add-css"]');
		var css = '';
		if ($asyncAddCss.length > 0) {
			$asyncAddCss.each(function (i,el) {
				css = $(el).val();
				$(el).append(css)
			});
		}

		//非同期取得する情報
		brand.spAsyncInfo();
	}
});